import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";

const StatusByPriority = ({ analytics = {} }) => {
  const categories = [
    "Critical",
    "High",
    "Medium",
    "Low",
  ];

  const series = [
    {
      name: "Open",
      data: [20, 35, 45, 25],
    },
    {
      name: "Answered",
      data: [10, 25, 35, 18],
    },
    {
      name: "Closed",
      data: [70, 155, 260, 140],
    },
    {
      name: "Re-opened",
      data: [2, 8, 12, 6],
    },
    {
      name: "Cancelled",
      data: [3, 10, 15, 5],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },

    colors: [
      "#2563eb", // Open
      "#7c3aed", // Answered
      "#1ea446", // Closed
      "#ea580c", // Re-opened
      "#94a3b8", // Cancelled
    ],

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 4,
      },
    },

    dataLabels: {
      enabled: false,
    },

    legend: {
      position: "top",
      horizontalAlign: "left",
      fontSize: "13px",
      markers: {
        width: 10,
        height: 10,
        radius: 2,
      },
    },

    xaxis: {
      categories,
    },

    yaxis: {
      min: 0,
      max: 400,
      tickAmount: 8,
    },

    grid: {
      borderColor: "#e2e8f0",
    },

    stroke: {
      width: 0,
    },

    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  return (
    <>
      <div className="p-3">
        <Chart
          options={options}
          series={series}
          type="bar"
          height={280}
        />
      </div>
    </>
  );
};

export default StatusByPriority;